import React, { useContext } from "react";

export const UserContext = React.createContext(null);

export default function useAuthedUser() {
  const [user, setUser] = useContext(UserContext);

  return [user, setUser];
}
